var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartinline = function SvgHeartinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeLinejoin: "round",
    d: "m11 19-1.45-1.295C4.4 13.125 1 10.103 1 6.395 1 3.374 3.42 1 6.5 1c1.74 0 3.41.795 4.5 2.05A6.04 6.04 0 0 1 15.5 1C18.58 1 21 3.374 21 6.395c0 3.708-3.4 6.73-8.55 11.32z"
  })));
};
export default SvgHeartinline;